module.exports = "#footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 50px;\n  margin-left: 74px;\n  background-color: #282727;\n  border-left: solid 1px #858585;\n  z-index: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/efficiency/efficiency.component.scss
// module id = ./src/app/entities/efficiency/efficiency.component.scss
// module chunks = main